import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page76() {
  useEffect(() => {
    document.title = "Маяк — Страница 75"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page74" />
        <ForwardLink href="/page76" />
      </div>

      <p style={{ textAlign: "right" }}>75.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Все, о чем я думал, когда он исчез под бревнами,<br/>
        “Вот бы сейчас покурить.” Вот<br/>
        и все. Итак, я собрал и упаковал его<br/>
        вещички, как будто они были мои. И,<br/>
        что ж, у Эфраима Уинслоу шикарная,<br/>
        безупречная репутация. У Томаса Ховарда —<br/>
        нет. Никаких перспектив. Как я еще<br/>
        смог бы найти достойную работу?
      </p>
      <p>Пауза.</p>
      <p>МОЛОДОЙ поворачивается. СТАРИКА нет... <i>Он вообще слышал это?</i></p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Том?
      </p>
      <p>Длинная пауза.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Том?!
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ЗА КАДРОМ)<br/>
        (издалека, шепотом,<br/>
        эхом)<br/>
        Зачем ты проболтался, Томми?
      </p>
      <br/>
      <p>ВНУТРИ. КУХНЯ/ДВЕРНОЙ ПРОЕМ ПЕРЕХОДА – НЕПРЕРЫВНО</p>
      <p>Голос СТАРИКА раздается эхом.</p>
      <br/>
      <p>ВНУТРИ. МАЯК. ЛЕСТНИЦА БАШНИ – НЕСКОЛЬКО МГНОВЕНИЙ СПУСТЯ</p>
      <p>Цепи звенят, тоже эхом...</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ЗА КАДРОМ)<br/>
        (шепотом)<br/>
        Зачем ты проболтался, Томми?
      </p>
      <p>МОЛОДОЙ поднимается по лестнице...</p>
      <br/>
      <p>ВНУТРИ. МАЯК. МАШИННОЕ ОТДЕЛЕНИЕ – НЕСКОЛЬКО МГНОВЕНИЙ СПУСТЯ</p>
      <p>ДВЕРЬ к ПОМОСТУ (внешней смотровой площадке) распахивается...</p>
      <p>Дождь сильно льет в машинное отделение.</p>
      <p>МОЛОДОЙ выходит через дверь...</p>
      <p style={{ textAlign: "right" }}>75.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page74" />
        <ForwardLink href="/page76" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710634724/the-lighthouse-script/apvcxsmjhnr7x7uizyar.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page76;
